module.exports = __webpack_public_path__ + "img/footer-payment-methods-mobile.3b114f73.png";